/* global axios */

import ApiClient from './ApiClient';

class AgendaAPI extends ApiClient {
  constructor() {
    super('appointment_schedules', { accountScoped: true });
  }

  // Schedules (Agenda types)
  getSchedules() {
    return axios.get(this.url);
  }

  getAvailability(id, params) {
    return axios.get(`${this.url}/${id}/availability`, { params });
  }

  // Resources (Professionals/Agents)
  getResources() {
    return axios.get(`${this.baseUrl()}/appointment_resources`);
  }

  createResource(data) {
    return axios.post(`${this.baseUrl()}/appointment_resources`, data);
  }

  updateResource(id, data) {
    return axios.patch(`${this.baseUrl()}/appointment_resources/${id}`, data);
  }

  deleteResource(id) {
    return axios.delete(`${this.baseUrl()}/appointment_resources/${id}`);
  }

  // Bookings
  getBookings(params) {
    return axios.get(`${this.baseUrl()}/appointment_bookings`, { params });
  }

  getBookingStats(params = {}) {
    return axios.get(`${this.baseUrl()}/appointment_bookings/stats`, {
      params,
    });
  }

  createBooking(data) {
    return axios.post(`${this.baseUrl()}/appointment_bookings`, data);
  }

  updateBooking(id, data) {
    return axios.patch(`${this.baseUrl()}/appointment_bookings/${id}`, data);
  }

  deleteBooking(id) {
    return axios.delete(`${this.baseUrl()}/appointment_bookings/${id}`);
  }

  // Messaging — creates a new conversation and sends the first message in one request
  sendBookingMessage(contactId, inboxId, content) {
    return axios.post(`${this.baseUrl()}/conversations`, {
      inbox_id: inboxId,
      contact_id: contactId,
      message: { content },
    });
  }

  testIcal(scheduleId) {
    return axios.get(`${this.url}/${scheduleId}/test_ical`);
  }

  // Regenerate the webhook secret for a schedule
  regenerateWebhookSecret(scheduleId) {
    return axios.post(`${this.url}/${scheduleId}/regenerate_webhook_secret`);
  }

  // Google Calendar OAuth — get authorization URL
  getGoogleCalendarAuthUrl(scheduleId) {
    return axios.post(
      `${this.url}/${scheduleId}/google_calendar_authorization`
    );
  }

  // Google Calendar OAuth — disconnect
  disconnectGoogleCalendar(scheduleId) {
    return axios.delete(
      `${this.url}/${scheduleId}/google_calendar_authorization`
    );
  }
}

export default new AgendaAPI();
